import { render, staticRenderFns } from "./VideoCourse.vue?vue&type=template&id=16ba56e8&"
import script from "./videoCourse.js?vue&type=script&lang=js&"
export * from "./videoCourse.js?vue&type=script&lang=js&"
import style0 from "./videoCourse.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports